import React from 'react';
import { Button, Popover, PopoverHeader, PopoverBody, Col, Row } from 'reactstrap';
import { getIcon } from "../lib/icons";
import './MonsterContainer.css';

class StatusPopover extends React.Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      popoverOpen: false
    };
  }

  toggle() {
    this.setState({
      popoverOpen: !this.state.popoverOpen
    });
  }

  render() {
    return (
      <span>
        <Button color="info" size="sm" id={this.props.id} onClick={this.toggle}>
          {this.props.text}
        </Button>
        <Popover placement={this.props.placement} isOpen={this.state.popoverOpen} target={this.props.id} toggle={this.toggle}>
          <PopoverHeader>
              <Row>
                <Col md="6">
                  Set Statuses
                </Col>
                <Col md="6" className="text-right">
                  <Button size="sm" onClick={() => { this.props.clearStatuses(this.props.monsterNumber); this.toggle()}}>Clear</Button>
                </Col>
              </Row>
          </PopoverHeader>
          <PopoverBody>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "poison") }}
              className={(this.props.statusList.poison ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("POISON")} alt="poison" /> 
            </Button>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "muddle") }}
              className={(this.props.statusList.muddle ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("MUDDLE")} alt="muddle" />
            </Button>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "wound") }}
              className={(this.props.statusList.wound ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("WOUND")} alt="wound" />
            </Button>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "immobilize") }}
              className={(this.props.statusList.immobilize ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("IMMOBILIZE")} alt="immobilize" />
            </Button>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "disarm") }}
              className={(this.props.statusList.disarm ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("DISARM")} alt="disarm" />
            </Button>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "stun") }}
              className={(this.props.statusList.stun ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("STUN")} alt="stun" />
            </Button>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "invisible") }}
              className={(this.props.statusList.invisible ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("INVISIBLE")} alt="invisible" />
            </Button>
            <Button onClick={() => { this.props.toggleStatus(this.props.monsterNumber, "strengthen") }}
              className={(this.props.statusList.strengthen ? "btn btn-secondary" : "btn btn-outline-secondary")}>
              <img className="img-fluid MonsterTracker--StatusEffectIcon" src={getIcon("STRENGTHEN")} alt="strengthen" />
            </Button>
          </PopoverBody>
        </Popover>
      </span>
    );
  }
}
export default StatusPopover;


// WEBPACK FOOTER //
// ./src/components/StatusPopover.js